<app-input-wrapper
  [label]="label"
  [required]="required"
  [errorMessage]="errorMessage"
  [touched]="touched"
  [disabled]="disabled"
>
  <div class="button-group" [attr.aria-label]="ariaLabel">
    <button
      *ngFor="let option of options"
      type="button"
      class="button-group__btn {{buttonClass}}"
      [class.selected]="isSelected(option)"
      [class.disabled]="disabled"
      [disabled]="disabled"
      (click)="select(option)"
    >
      {{ option.label }}
    </button>
  </div>
</app-input-wrapper>
